import { headers } from '../const/headers'
import { vehicleMaintenanceDefault } from '../domain/vehicleMaintenance/vehicleMaintenance'
import * as XLSX from "xlsx";
import { snackbar } from '@/core/controller/snackbar_controller';
import { hadColumnsAccess } from '@/core/domain/model/permission';

class VehicleMaintenanceController {
    context = null;
    headers = headers;
    loading = false;
    loadingBtnExcel = false;
    search = "";
    dialog = false;
    form = vehicleMaintenanceDefault()

    vehicleMaintenancePagination = {
        total: 0,
        items: []
    }

    options = {
      page: 1,
      itemsPerPage: 40,
      groupBy: [],
      sortBy: ["createdDate"],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      sortDesc: [true]
    }

    clientPagination = {
        total: 0,
        items: []
    }
    
    clientOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["name"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    vehiclePagination = {
        total: 0,
        items: []
    }
    
    vehicleOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["plate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    constructor(
        context,
        fetchVehicleMaintenanceUseCaseImpl,
        createVehicleMaintenanceUseCaseImpl,
        deleteVehicleMaintenanceUseCaseImpl,
        fetchClientUseCaseImpl,
        fetchVehicleUseCaseImpl

    ) {
        this.context = context,
        this.fetchVehicleMaintenanceUseCaseImpl = fetchVehicleMaintenanceUseCaseImpl,
        this.createVehicleMaintenanceUseCaseImpl = createVehicleMaintenanceUseCaseImpl,
        this.deleteVehicleMaintenanceUseCaseImpl = deleteVehicleMaintenanceUseCaseImpl,
        this.fetchClientUseCaseImpl = fetchClientUseCaseImpl,
        this.fetchVehicleUseCaseImpl = fetchVehicleUseCaseImpl
    }

    async paginate() {
        this.loading = true
        try {
            const response = await this.fetchVehicleMaintenanceUseCaseImpl(this.options, this.search)
            
            response.items = response.items.map(item => {
                const equipments = item.equipments || [];
                
                return {
                    ...item,
                    expanded: false,
                    equipments: equipments.map(eq => ({
                        model: eq.model,
                        type: eq.equipmentTypeID === 1 ? 'Jammer Principal' : 'Auxiliar'
                    }))
                }
            })
    
            this.vehicleMaintenancePagination = response
                
        } catch (error) {
            console.log(error)
        } finally {
            this.loading = false
        }
    }

    async clientPaginate() {
        try {
          this.clientPagination = await this.fetchClientUseCaseImpl(this.clientOptions, this.searchClient)
        } catch (error) {
          console.log(error);
        }
    };

    getColumnsAccess() {
        return this.headers.filter(header => hadColumnsAccess(header.value))
    }

    async vehiclePaginate() {
        try {
          this.vehiclePagination = await this.fetchVehicleUseCaseImpl(this.vehicleOptions, this.searchVehicle)
        } catch (error) {
          console.log(error);
        }
    };

    async delete (item) {
        try {
            const confirm = await snackbar.confirm({ message: 'Deseja realmente excluir o registro?', color: 'primary', timeout: 5000 });
            if (confirm) {
                await this.deleteVehicleMaintenanceUseCaseImpl(item.id);
                this.paginate();
                snackbar.show({ message: 'Registro excluído!', color: '#008000', timeout: 1000 })
            }
        } catch (error) {
            snackbar.show({ message: error.toString() })
        }
    }

    watchOptions() {
        this.paginate()
    }
    watchSearch() {
        this.paginate()
    }
    watchClientOptions() {
        this.clientPaginate()
    }
    watchClientSearch() {
        this.clientPaginate()
    }
    watchVehicleOptions() {
        this.vehiclePaginate()
    }
    watchVehicleSearch() {
        this.vehiclePaginate()
    }

    async exportExcel() {
        try {
          const header = [['DATA DE CRIACAO', 'DESCRICAO', 'CLIENTE', 'PLACA', 'ISOLADO', 'CRIADO POR', 'EQUIPAMENTOS', 'CUSTO', 'VALOR (R$)', 'RESPONSAVEL']];
          this.loadingBtnExcel = true;
          const paginate = { ...this.options };
          paginate.itemsPerPage = 30000;
          const data = await this.fetchVehicleMaintenanceUseCaseImpl(paginate, ""); 

          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.json_to_sheet([]);
          XLSX.utils.sheet_add_aoa(ws, header);
          XLSX.utils.sheet_add_json(ws, data.items.map((item) => {
            return {
                createdDate: item.createdDate,
                description: item.description,
                clientName: item.clientName,
                plate: item.plate,
                isolated: item.isolated,
                account: item.account,
                equipments: item.equipments && item.equipments.length > 0
                  ? item.equipments.map(eq => `${eq.name} (${eq.model} - ${eq.type})`).join(', ')
                  : '',
                hadCost: item.hadCost,
                cost: item.cost / 100,
                costResponsibility: item.costResponsibility
              };
          }), { origin: 'A2', skipHeader: true });
          XLSX.utils.book_append_sheet(wb, ws, 'vehicleMaintenance');
          XLSX.writeFile(wb, `manutencao-veiculos.xlsx`);
        } catch (error) {
          snackbar.show({ message: error.toString() });
        } finally {
          this.loadingBtnExcel = false;
        }
    }

    async exportExcelClientAdmin() {
    try {
        const header = [['DATA DE CRIACAO', 'DESCRICAO', 'CLIENTE', 'PLACA', 'EQUIPAMENTOS']];
        this.loadingBtnExcel = true;
        const paginate = { ...this.options };
        paginate.itemsPerPage = 30000;
        const data = await this.fetchVehicleMaintenanceUseCaseImpl(paginate, ""); 

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet([]);
        XLSX.utils.sheet_add_aoa(ws, header);
        XLSX.utils.sheet_add_json(ws, data.items.map((item) => {
            return {
                createdDate: item.createdDate,
                description: item.description,
                clientName: item.clientName,
                plate: item.plate,
                equipments: item.equipments && item.equipments.length > 0
                    ? item.equipments.map(eq => `${eq.model} - ${eq.type}`).join(', ')
                    : ''
            };
        }), { origin: 'A2', skipHeader: true });
        XLSX.utils.book_append_sheet(wb, ws, 'vehicleMaintenance');
        XLSX.writeFile(wb, `manutencao-veiculos.xlsx`);
    } catch (error) {
        snackbar.show({ message: error.toString() });
    } finally {
        this.loadingBtnExcel = false;
    }
}

}

export default VehicleMaintenanceController